import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSingleProductData } from '../Api/products';
import { sanitizeRichText } from '../utils/sanitizeHtml';
import { toast } from 'react-toastify';
import { Box, Rating } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

function RelatedProduct({ isAuthenticated, productId, onAddToCart }) {
    const [discount, setDiscount] = useState(0);
    const [product, setProduct] = useState(null);
    const navigate = useNavigate();
    const [productCount, setProductCount] = useState(1);

    useEffect(() => {
        const fetchSingleProduct = async () => {
            try {
                const data = await getSingleProductData(productId);
                setProduct(data);
            } catch (error) {
                console.error("Failed to fetch product:", error);
            }
        };
        if (productId) {
            fetchSingleProduct();
        }
    }, [productId]);

    useEffect(() => {
        if (product?.sale_price && product?.regular_price) {
            const disc = (((product.regular_price || product.price) - product.sale_price) / product.regular_price) * 100;
            setDiscount(Math.round(disc));
        }
    }, [product]);

    const singleProductPage = () => {
        navigate(`/product/${productId}`);
    };

    if (!product) return null;

    function addCart() {
        if (isAuthenticated) {
            onAddToCart(product, productCount)
        }
        else {
            navigate('/login');
            toast.error("Please login first!")
        }
    }

    return (
        <div className="product-card" style={{ margin: "0 2% 0 0"}}>
            <img
                src={product?.images[0]?.src}
                alt={product.name}
                className='product-card-image'
                onClick={singleProductPage}
                style={{ cursor: "pointer" }}
            />
            {product.sale_price && (
                <div className="product-discount-tag">
                    <span>{discount}% OFF</span>
                </div>
            )}
            <div className="product-card-text">
                <h5 style={{ cursor: "pointer" }} onClick={singleProductPage}>
                    {product.name}
                </h5>
                <p
                    className='product-card-description'
                    dangerouslySetInnerHTML={{ __html: sanitizeRichText(product?.description) }}
                />
                <div style={{ margin: 'auto', width: 'fit-content' }}>
                    <Box sx={{ width: "fit-content", display: 'flex', alignItems: 'center', margin: "auto" }}>
                        <Rating
                            name="text-feedback"
                            value={product.average_rating}
                            readOnly
                            precision={0.5}
                            emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                        />
                    </Box>
                    <p style={{ textAlign: 'center' }}>{product.rating_count} Rattings</p>
                </div>
            </div>
            <div className="product-card-pricing d-flex">
                <div className="product-price-tag d-flex">
                    {product.stock_status === "instock" ? (
                        <div style={{textAlign:'center'}}>
                            {product.sale_price === "" ? (
                                <span>₹{product.regular_price || product.price}</span>
                            ) : (
                                <>
                                    <strike style={{ padding: "4px 0 0", fontSize: "14px" }}>
                                        ₹{product.regular_price || product.price}
                                    </strike>
                                    <span style={{ marginLeft: "5px", fontSize: "18px" }}>
                                        ₹{product.sale_price}
                                    </span>
                                </>
                            )}
                        </div>
                    ) : (
                        <div className="product-out-of-stock"  style={{textAlign:'center'}}>out of stock</div>
                    )}
                    <button
                        className='product-card-btn'
                        onClick={addCart}
                        style={{ padding: '3px 16px', border: '1px solid transparent',display:'block', borderRadius: '5px', cursor: 'pointer',margin:'auto' }}
                    >
                        Add
                    </button>
                </div>
            </div>
        </div>
    );
}

export default RelatedProduct;
